import { useState } from "react";
import { Controller } from "react-hook-form";
import { AsyncPaginate } from "react-select-async-paginate";
import { customersApi } from "../../../../features/api/customers/customersApi";
import { Form } from "react-bootstrap";

export const AsyncCustomerSelect = ({
  control,
  errors,
  setValue,
  dispatch,
  setSelectedCustomer,
}) => {
  const [selectedCustomerName, setSelectedCustomerName] = useState("");

  const loadCustomerOptions = async (search, loadedOptions, { page }) => {
    const response = await dispatch(
      customersApi.endpoints.getCustomers.initiate({
        page: page - 1,
        size: 5,
        companyName: search,
      }),
    );

    const data = response?.data;
    const options =
      data?.content?.map((company) => ({
        value: company.id,
        label: capitalizeWords(company.companyName),

        // full object
        customer: company,
      })) || [];

    return {
      options,
      hasMore: !data?.last,
      additional: { page: page + 1 },
    };
  };

  const capitalizeWords = (str) => {
    if (!str) return "";
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <Form.Group>
      <Form.Label>Customer</Form.Label>
      <Controller
        control={control}
        name="customerId"
        render={({ field }) => (
          <AsyncPaginate
            value={
              field.value
                ? {
                    value: field.value,
                    label: selectedCustomerName || "Loading...",
                  }
                : null
            }
            loadOptions={loadCustomerOptions}
            onChange={(option) => {
              field.onChange(option?.value);
              setValue("customerId", option?.value);
              setSelectedCustomerName(capitalizeWords(option?.label));
              setSelectedCustomer(option?.customer);
            }}
            additional={{ page: 1 }}
            isClearable
            placeholder="Search Company..."
          />
        )}
      />
      {errors.customerId && (
        <p className="text-danger">{errors.customerId.message}</p>
      )}
    </Form.Group>
  );
};
